import { fetcher } from '@/config/api';

export interface MeResponse {
  user: Record<string, any>;
}

export async function getMe(): Promise<MeResponse> {
  return fetcher<MeResponse>('/api/me');
}

export async function logout(): Promise<void> {
  // Notify the backend (clears any server-side state / analytics)
  try {
    await fetcher<void>('/api/logout', { method: 'POST' });
  } catch {
    // Non-fatal — continue with client-side logout
  }
  // Clear legacy localStorage session
  localStorage.removeItem('session');
  // MSAL logout: clears sessionStorage tokens and ends the Azure AD session
  const { msalInstance } = await import('../config/msal');
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  if (account) {
    await msalInstance.logoutRedirect({ account });
  }
}
